import React from 'react'
import { FormItem, Select } from 'formik-antd'
import citizen_codes from '../../../../assets/citizen_codes.json'
import locales from '../../../../assets/locales.json'

const { Option } = Select

export const CountrySelect: React.FunctionComponent = () => {
  const locales_cc = locales.ru.citizen_codes

  return (
    <FormItem name="countryCode" label="Гражданство" required>
      <Select
        showSearch
        name="countryCode"
        placeholder="Гражданство"
        optionFilterProp="children"
      >
        {citizen_codes.map((code) => (
          <Option value={code} key={code}>
            {locales_cc[code as keyof typeof locales_cc]}
          </Option>
        ))}
      </Select>
    </FormItem>
  )
}
